// @flow

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

import { Link } from 'components/Gui';
import type { LinkProps } from 'components/Gui/links/Link';
import { buttonDefault, Color, flex, hoverMultiple, Width } from 'styles';

const Themes = {
  PRIMARY: 'PRIMARY',
  FILLED: 'FILLED',
};

const Wrapper = styled.div`
  display: inline-block;
  height: ${({ mobileLarge }) => (mobileLarge ? 48 : 36)}px;
  max-width: 100%;
  ${({ mobileLarge }) =>
    mobileLarge &&
    css`
      width: 320px;
      @media print, screen and (min-width: ${Width.BREAK_MD}px) {
        display: inline-block;
        width: unset;
        height: 4rem;
      }
    `};
  a,
  button {
    ${flex()};
    padding: 0 ${({ padding }) => padding}px;
    border-radius: 6px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    text-decoration: none;
    ${buttonDefault};
    background: linear-gradient(to right, #38b34a, #046938);
    color: white;
    ${({ theme, noFocus }) =>
      theme === Themes.PRIMARY &&
      css`
        ${hoverMultiple(
          [
            {
              prop: 'transform',
              base: 'none',
              hover: 'translate(2px, -2px)',
            },
            {
              prop: 'box-shadow',
              base: 'none',
              hover: '0 2px 2px rgba(0, 0, 0, 0.2)',
            },
          ],
          noFocus
        )}
      `}
    ${({ theme, noFocus }) =>
      theme === Themes.FILLED &&
      css`
        ${hoverMultiple(
          [
            {
              prop: 'color',
              base: Color.BLACK_SOUL,
              hover: Color.WHITE,
            },
            {
              prop: 'background',
              base: Color.YELLOW_MELLOW,
              hover: Color.PURPLE_FIGURE,
            },
          ],
          noFocus
        )}
      `}
  }
`;

export type Props = {
  theme?: $Keys<typeof Themes>,
  padding?: number,
  mobileLarge?: boolean,
  children: Node,
  noFocus?: boolean,
};

const Button = ({
  theme = Themes.PRIMARY,
  padding = 32,
  mobileLarge = false,
  noFocus = false,
  children,
  className = '',
  ...rest
}: LinkProps & Props) => (
  <Wrapper theme={theme} mobileLarge={mobileLarge} padding={padding} noFocus={noFocus} className={className}>
    <Link {...rest}>{children}</Link>
  </Wrapper>
);

export default Button;
